var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M50,0A50,50 0 1 1 50,100A50,50 0 1 1 50,0ZM72.77 45.508a20.523 20.523 0 0 1 -11.995 -3.835V59.134A15.881 15.881 0 1 1 47.075 43.398V52.18a7.29 7.29 0 1 0 5.103 6.954V25l8.598 0a11.839 11.839 0 0 0 0.182 2.166h0A11.937 11.937 0 0 0 66.224 35.004a11.864 11.864 0 0 0 6.546 1.968Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok_icon.cf2040eebccdc67f43f8c21cbfbe9c5b.svg";
export { ForwardRef as ReactComponent };